import { useLayoutEffect, useRef } from 'react';
export const STICKY_THRESHOLD_PX = 32;
export const isWithinStickyThreshold = (scrollHeight, scrollTop, clientHeight)=>scrollHeight - scrollTop - clientHeight <= STICKY_THRESHOLD_PX;
export const useStickyAutoScroll = ()=>{
    const scrollRef = useRef(null);
    const contentRef = useRef(null);
    const isStickyRef = useRef(true);
    const lastScrollTopRef = useRef(0);
    const onScroll = ()=>{
        const scroll = scrollRef.current;
        if (scroll == null) return;
        const movedUp = scroll.scrollTop < lastScrollTopRef.current;
        lastScrollTopRef.current = scroll.scrollTop;
        if (isWithinStickyThreshold(scroll.scrollHeight, scroll.scrollTop, scroll.clientHeight)) {
            isStickyRef.current = true;
        } else if (movedUp) {
            isStickyRef.current = false;
        }
    };
    const scrollToBottom = ()=>{
        const scroll = scrollRef.current;
        if (scroll == null) return;
        isStickyRef.current = true;
        scroll.scrollTop = scroll.scrollHeight;
        lastScrollTopRef.current = scroll.scrollTop;
    };
    useLayoutEffect(()=>{
        const scroll = scrollRef.current;
        const content = contentRef.current;
        if (scroll == null || content == null) return;
        const observer = new ResizeObserver(()=>{
            if (!isStickyRef.current) return;
            if (scroll.scrollHeight <= scroll.clientHeight) return;
            scroll.scrollTop = scroll.scrollHeight;
            lastScrollTopRef.current = scroll.scrollTop;
        });
        observer.observe(content);
        observer.observe(scroll);
        return ()=>observer.disconnect();
    }, []);
    return {
        scrollRef,
        contentRef,
        onScroll,
        scrollToBottom
    };
};
